import React, { useState, useEffect } from "react";
import { Edit2, Plus, X } from "react-feather";
import DatePicker from "react-datepicker";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { baseurl, imageUrl } from "../../../Baseurl"; 
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const EditStrategicInitiative = ({id}) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [attachments, setAttachments] = useState([]);

// const [attachments, setAttachments] = useState([]);
const [previews, setPreviews] = useState([]);



 const adminID = localStorage.getItem("adminID");
 const org_id = localStorage.getItem("org_id");

const [existingFiles, setExistingFiles] = useState([]);
 // Update to match your backend URL


 const [formData, setFormData] = useState({
  title: "",
  description: "",
  department: "",
  priority: "Low",
  category: "Maintenance",
  tags: "",
  estimatedTime: "",
  assignedTo: "",
  supervisor: "",
  createdBy: "",
  status: "Not Started",
  riskLevel: "Low",
  estimatedBudget: "",
  kpi: "",
});


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

 const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  setAttachments(files);

  const previewURLs = files.map(file => ({
    name: file.name,
    url: URL.createObjectURL(file),
  }));

  setPreviews(previewURLs);
};




useEffect(() => {
  const fetchInitiative = async () => {
    if (id) {
      try {
        const res = await axios.get(`${baseurl}getStrategicInitiativesById/${id}`);
        const data = res.data.data[0];

        setFormData({
          title: data.title || "",
          description: data.description || "",
          department: data.department || "",
          priority: data.priority || "Low",
          category: data.category || "Maintenance",
          tags: data.tags || "",
          estimatedTime: data.estimated_time || "",
          assignedTo: data.assigned_to || "",
          supervisor: data.supervisor || "",
          createdBy: data.created_by || "",
          status: data.status || "Not Started",
          riskLevel: data.risk_level || "Low",
          estimatedBudget: data.estimated_budget || "",
          kpi: data.kpi || "",
        });

        // ✅ Fix attachment parsing
        if (data.attachment) {
          try {
            const parsed = JSON.parse(data.attachment);
            if (Array.isArray(parsed)) {
              setExistingFiles(parsed);
            } else {
              setExistingFiles([data.attachment]);
            }
          } catch (err) {
            // If not JSON, treat as single string
            setExistingFiles([data.attachment]);
          }
        } else {
          setExistingFiles([]);
        }

        setStartDate(data.start_date ? new Date(data.start_date) : null);
        setDueDate(data.due_date ? new Date(data.due_date) : null);
      } catch (err) {
        console.error("Error fetching initiative:", err);
      }
    }
  };

  fetchInitiative();
}, [id]);

useEffect(() => {
  console.log("existingFiles", existingFiles);
}, [existingFiles]);



const handleUpdate = async (e) => {
  e.preventDefault();

  const form = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    form.append(key, value);
  });

  if (startDate) form.append("startDate", startDate.toISOString());
  if (dueDate) form.append("dueDate", dueDate.toISOString());
  form.append("admin_id", adminID);
  form.append("org_id", org_id);

  attachments.forEach((file, index) => {
    form.append("File", file);
  });

  // Logging omitted for brevity...

  try {
    const response = await axios.post(`${baseurl}updateStrategicInitiative/${id}`, form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("Update Success:", response.data);

    // Show success toast
    toast.success("Strategic initiative updated successfully! Wait For Page Load");

    // Reload page after 2 seconds
    setTimeout(() => {
      window.location.reload();
    }, 2000);

    setStartDate(null);
    setDueDate(null);
    setAttachments([]);
    setShowDrawer(false);

  } catch (error) {
    console.error("Update failed:", error);
    toast.error("Update failed. Please try again.");
  }
};



  return (
    <>
      {/* <button className="new-project-btn oneline me-2" onClick={() => setShowDrawer(true)}>
        <Plus /> &nbsp;Edit Strategic Initiative
      </button> */}

        <button className="btn btn-sm btn-outline-secondary  d-flex justify-content-center align-items-center" onClick={() => setShowDrawer(true)}>
       <Edit2 size={15}/> Edit
        </button>


      {showDrawer && (
        <div className="offcanvas-overlay" onClick={() => setShowDrawer(false)}>
          <div className="offcanvas-content" onClick={(e) => e.stopPropagation()}>
            <div className="offcanvas-header">
              <h5>{formData.title}</h5>
              <X className="close-icon" onClick={() => setShowDrawer(false)} />
            </div>

            <div className="offcanvas-body">
              <form onSubmit={handleUpdate}>
                <div className="row g-2 text-start">
                  <div className="col-md-12">
                    <label className="form-label">Title</label>
                    <input name="title" className="form-control" value={formData.title} onChange={handleChange} />
                  </div>

                  <div className="col-md-12">
                    <label className="form-label">Description</label>
                    <textarea name="description" className="form-control" rows="3" value={formData.description} onChange={handleChange}></textarea>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Department</label>
                    <input name="department" className="form-control" value={formData.department} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Priority</label>
                    <select name="priority" className="form-control" value={formData.priority} onChange={handleChange}>
                      <option>Low</option>
                      <option>Medium</option>
                      <option>High</option>
                      <option>Urgent</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Category / Type</label>
                    <select name="category" className="form-control" value={formData.category} onChange={handleChange}>
                      <option>Maintenance</option>
                      <option>Logistics</option>
                      <option>IT</option>
                      <option>HR</option>
                      <option>Finance</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Tags / Labels</label>
                    <input name="tags" className="form-control" value={formData.tags} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Start Date</label>
                    <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} dateFormat="dd/MM/yyyy" className="form-control" placeholderText="Select start date" />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Due Date / Deadline</label>
                    <DatePicker selected={dueDate} onChange={(date) => setDueDate(date)} dateFormat="dd/MM/yyyy" className="form-control" placeholderText="Select due date" />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Estimated Time</label>
                    <input name="estimatedTime" className="form-control" value={formData.estimatedTime} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Assigned To</label>
                    <input name="assignedTo" className="form-control" value={formData.assignedTo} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Supervisor / Approver</label>
                    <input name="supervisor" className="form-control" value={formData.supervisor} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Created By</label>
                    <input name="createdBy" className="form-control" value={formData.createdBy} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Status</label>
                    <select name="status" className="form-control" value={formData.status} onChange={handleChange}>
                      <option>Not Started</option>
                      <option>In Progress</option>
                      <option>Completed</option>
                      <option>On Hold</option>
                      <option>Cancelled</option>
                    </select>
                  </div>

<div className="col-md-6">
  <label className="form-label">Attachments</label>
  <input
    type="file"
    name="attachments"
    className="form-control"
    multiple
    onChange={handleFileChange}
  />

  {/* Show existing uploaded file preview buttons */}
  {existingFiles && existingFiles.length > 0 && (
    <div className="mt-2">
      <strong>Uploaded Files:</strong>
      {existingFiles.map((fileString, idx) => {
        // Split the comma-separated string into array of filenames
        const filesArray = fileString.split(',').map(f => f.trim()).filter(Boolean);
        return filesArray.map((filename, i) => (
          <div key={`${idx}-${i}`} className="d-flex align-items-center my-1">
            <a
              href={`${imageUrl}strategic_initiatives/${filename}`}
              target="_blank"
              rel="noopener noreferrer"
              className="me-2"
            >
              {filename}
            </a>
          </div>
        ));
      })}
    </div>
  )}
</div>




                  <div className="col-md-6">
                    <label className="form-label">Risk Level</label>
                    <select name="riskLevel" className="form-control" value={formData.riskLevel} onChange={handleChange}>
                      <option>Low</option>
                      <option>Medium</option>
                      <option>High</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Estimated Budget</label>
                    <input name="estimatedBudget" type="number" className="form-control" value={formData.estimatedBudget} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Success Metrics / KPIs</label>
                    <input name="kpi" className="form-control" value={formData.kpi} onChange={handleChange} />
                  </div>
                </div>

                <div className="mt-4 text-end">
                  <button type="submit" className="btn submitbtnn">Save Changes</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        
      )}


      <ToastContainer
    position="top-center"
    autoClose={3000}    // Toast disappears after 3 seconds
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    theme="colored"
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />



    </>
  );
};

export default EditStrategicInitiative;
